import { MobileNotSupportedImage } from 'assets/icons';
import messages from './MobileNotSupported.messages';
import styles from './MobileNotSupported.module.css';

const MobileNotSupported = (): JSX.Element => (
  <div className={styles.mobileNotSupported}>
    <MobileNotSupportedImage />
    <h1 className={styles.mobileNotSupported__title}>{messages.title}</h1>
    <p className={styles.mobileNotSupported__text}>{messages.text}</p>
  </div>
);

export default MobileNotSupported;
